import React, {Fragment} from 'react';
import {moment, shorten, split, useNamedSelector} from 'helpers';
import {NoWrap, Icon, Icons, Activities, Card, Flex, SyncIcon} from 'components';

export function Footer(props) {
  const { activity, time, timeframe, allDay, hideTimer } = props;
  return (
    <Card.Footer>
      <Flex>
        <Repetition id={activity.id} />

        { timeframe != 'muted' && !hideTimer &&
          <Activities.Timer inline {...props} />
        }

        { timeframe != 'muted' && !allDay && ( time || activity.time || activity.dayParts ) &&
          <Fragment>
            <Icons.Clock className={`${Card.css.highlight} pull-right`} />
            <NoWrap>{ time || activity.time || shorten(activity.dayParts, { words: 1 }) }</NoWrap>
          </Fragment>
        }
      </Flex>
    </Card.Footer>
  );
}

export function Repetition({id}) {
  const {activity, type, saved, repetition, timeframe} = useNamedSelector('activities.details', {id});
  const [first, second] = split(repetition, ' | ');
  return (
    <>
      { saved
        ? <Icon name={activity.priority ? 'flag-filled' : type} className={Card.css.highlight} />
        : <SyncIcon className={Card.css.highlight} />
      }

      <NoWrap className="no-wrap-ellipsis">
        { first }
        { second &&
          <Card.Note>{ second }</Card.Note>
        }
      </NoWrap>

      { timeframe == 'muted' &&
        <div>ended on { moment.unix(activity.endDate).format() }</div>
      }
    </>
  );
}
